// src/api/devoluciones.js
import { apiFetch } from './index';

// =====================================================
// DEVOLUCIONES (CABECERA)
// =====================================================

/**
 * Obtener todas las devoluciones
 */
export const obtenerDevoluciones = async () => {
  try {
    return await apiFetch('/Devolucion');
  } catch (error) {
    console.error('❌ Error obteniendo devoluciones:', error);
    throw error;
  }
};

/**
 * Obtener devolución por ID
 */
export const obtenerDevolucionPorId = async (idDevolucion) => {
  try {
    return await apiFetch(`/Devolucion/${idDevolucion}`);
  } catch (error) {
    console.error(`❌ Error obteniendo devolución ${idDevolucion}:`, error);
    throw error;
  }
};

/**
 * Obtener devolución con relaciones (conteos)
 */
export const obtenerDevolucionConRelaciones = async (idDevolucion) => {
  try {
    return await apiFetch(`/Devolucion/${idDevolucion}/conRelaciones`);
  } catch (error) {
    console.error(`❌ Error obteniendo devolución con relaciones ${idDevolucion}:`, error);
    throw error;
  }
};

/**
 * Obtener devoluciones pendientes
 */
export const obtenerDevolucionesPendientes = async () => {
  try {
    return await apiFetch('/Devolucion/pendientes');
  } catch (error) {
    console.error('❌ Error obteniendo devoluciones pendientes:', error);
    throw error;
  }
};

/**
 * Obtener devoluciones por estado
 */
export const obtenerDevolucionesPorEstado = async (estado) => {
  try {
    return await apiFetch(`/Devolucion/estado/${estado}`);
  } catch (error) {
    console.error(`❌ Error obteniendo devoluciones con estado ${estado}:`, error);
    throw error;
  }
};

/**
 * Obtener devoluciones por tipo de origen
 */
export const obtenerDevolucionesPorTipoOrigen = async (tipoOrigen) => {
  try {
    return await apiFetch(`/Devolucion/tipoOrigen/${tipoOrigen}`);
  } catch (error) {
    console.error(`❌ Error obteniendo devoluciones de tipo ${tipoOrigen}:`, error);
    throw error;
  }
};

/**
 * Obtener devoluciones por cliente
 */
export const obtenerDevolucionesPorCliente = async (idCliente) => {
  try {
    return await apiFetch(`/Devolucion/cliente/${idCliente}`);
  } catch (error) {
    console.error(`❌ Error obteniendo devoluciones del cliente ${idCliente}:`, error);
    throw error;
  }
};

/**
 * Buscar devoluciones por criterios avanzados
 */
export const buscarDevoluciones = async (searchDTO) => {
  try {
    return await apiFetch('/Devolucion/search', {
      method: 'POST',
      body: searchDTO
    });
  } catch (error) {
    console.error('❌ Error buscando devoluciones:', error);
    throw error;
  }
};

/**
 * Crear una nueva devolución
 */
export const crearDevolucion = async (createDTO) => {
  try {
    return await apiFetch('/Devolucion', {
      method: 'POST',
      body: createDTO
    });
  } catch (error) {
    console.error('❌ Error creando devolución:', error);
    throw error;
  }
};

/**
 * Actualizar una devolución
 */
export const actualizarDevolucion = async (id, updateDTO) => {
  try {
    return await apiFetch(`/Devolucion/${id}`, {
      method: 'PUT',
      body: updateDTO
    });
  } catch (error) {
    console.error(`❌ Error actualizando devolución ${id}:`, error);
    throw error;
  }
};

/**
 * Anular/eliminar devolución
 */
export const anularDevolucion = async (idDevolucion) => {
  try {
    return await apiFetch(`/Devolucion/${idDevolucion}`, {
      method: 'DELETE'
    });
  } catch (error) {
    console.error(`❌ Error anulando devolución ${idDevolucion}:`, error);
    throw error;
  }
};

/**
 * Aprobar devolución
 */
export const aprobarDevolucion = async (id, idUsuarioAprueba) => {
  try {
    return await apiFetch(`/Devolucion/${id}/aprobar?idUsuarioAprueba=${idUsuarioAprueba}`, {
      method: 'POST'
    });
  } catch (error) {
    console.error(`❌ Error aprobando devolución ${id}:`, error);
    throw error;
  }
};

/**
 * Rechazar devolución
 */
export const rechazarDevolucion = async (id, idUsuarioAprueba, motivo) => {
  try {
    return await apiFetch(
      `/Devolucion/${id}/rechazar?idUsuarioAprueba=${idUsuarioAprueba}&motivo=${encodeURIComponent(motivo)}`,
      { method: 'POST' }
    );
  } catch (error) {
    console.error(`❌ Error rechazando devolución ${id}:`, error);
    throw error;
  }
};

/**
 * Completar devolución
 */
export const completarDevolucion = async (id) => {
  try {
    return await apiFetch(`/Devolucion/${id}/completar`, { method: 'POST' });
  } catch (error) {
    console.error(`❌ Error completando devolución ${id}:`, error);
    throw error;
  }
};

/**
 * Anular devolución con motivo
 */
export const anularDevolucionConMotivo = async (id, motivo) => {
  try {
    return await apiFetch(
      `/Devolucion/${id}/anular?motivo=${encodeURIComponent(motivo)}`,
      { method: 'POST' }
    );
  } catch (error) {
    console.error(`❌ Error anulando devolución ${id}:`, error);
    throw error;
  }
};

/**
 * Obtener estadísticas generales
 */
export const obtenerEstadisticasDevoluciones = async () => {
  try {
    return await apiFetch('/Devolucion/estadisticas');
  } catch (error) {
    console.error('❌ Error obteniendo estadísticas:', error);
    throw error;
  }
};

// =====================================================
// DETALLES DE DEVOLUCIÓN
// =====================================================

export const obtenerDetallesDevolucion = async (idDevolucion) => {
  try {
    return await apiFetch(`/DevolucionDetalle/devolucion/${idDevolucion}`);
  } catch (error) {
    console.error(`❌ Error obteniendo detalles:`, error);
    throw error;
  }
};

export const crearDetalleDevolucion = async (createDTO) => {
  try {
    return await apiFetch('/DevolucionDetalle', {
      method: 'POST',
      body: createDTO
    });
  } catch (error) {
    console.error('❌ Error creando detalle:', error);
    throw error;
  }
};

export const actualizarDetalleDevolucion = async (id, updateDTO) => {
  try {
    return await apiFetch(`/DevolucionDetalle/${id}`, {
      method: 'PUT',
      body: updateDTO
    });
  } catch (error) {
    console.error(`❌ Error actualizando detalle ${id}:`, error);
    throw error;
  }
};

export const eliminarDetalleDevolucion = async (id) => {
  try {
    return await apiFetch(`/DevolucionDetalle/${id}`, {
      method: 'DELETE'
    });
  } catch (error) {
    console.error(`❌ Error eliminando detalle ${id}:`, error);
    throw error;
  }
};

// =====================================================
// PAGOS / REEMBOLSOS
// =====================================================

export const obtenerPagosDevolucion = async (idDevolucion) => {
  try {
    return await apiFetch(`/DevolucionPago/devolucion/${idDevolucion}`);
  } catch (error) {
    console.error('❌ Error obteniendo pagos:', error);
    throw error;
  }
};

export const registrarPagoDevolucion = async (createDTO) => {
  try {
    return await apiFetch('/DevolucionPago', {
      method: 'POST',
      body: createDTO
    });
  } catch (error) {
    console.error('❌ Error registrando pago:', error);
    throw error;
  }
};

export const anularPagoDevolucion = async (id, motivo) => {
  try {
    return await apiFetch(
      `/DevolucionPago/${id}/anular?motivo=${encodeURIComponent(motivo)}`,
      { method: 'POST' }
    );
  } catch (error) {
    console.error(`❌ Error anulando pago ${id}:`, error);
    throw error;
  }
};

// =====================================================
// HISTORIAL
// =====================================================

export const obtenerHistorialDevolucion = async (idDevolucion) => {
  try {
    return await apiFetch(`/HistorialDevolucion/devolucion/${idDevolucion}`);
  } catch (error) {
    console.error('❌ Error obteniendo historial:', error);
    throw error;
  }
};

// =====================================================
// SECUENCIAS
// =====================================================

export const previsualizarSiguienteNumero = async (prefijo = 'DEV-') => {
  try {
    return await apiFetch(`/SecuenciaDevolucion/previsualizar?prefijo=${prefijo}`);
  } catch (error) {
    console.error('❌ Error previsualizando número:', error);
    throw error;
  }
};

// =====================================================
// EXPORT DEFAULT
// =====================================================
export default {
  // Cabecera
  obtenerDevoluciones,
  obtenerDevolucionPorId,
  obtenerDevolucionConRelaciones,
  obtenerDevolucionesPendientes,
  obtenerDevolucionesPorEstado,
  obtenerDevolucionesPorTipoOrigen,
  obtenerDevolucionesPorCliente,
  buscarDevoluciones,
  crearDevolucion,
  actualizarDevolucion,
  anularDevolucion,
  aprobarDevolucion,
  rechazarDevolucion,
  completarDevolucion,
  anularDevolucionConMotivo,
  obtenerEstadisticasDevoluciones,

  // Detalles
  obtenerDetallesDevolucion,
  crearDetalleDevolucion,
  actualizarDetalleDevolucion,
  eliminarDetalleDevolucion,

  // Pagos
  obtenerPagosDevolucion,
  registrarPagoDevolucion,
  anularPagoDevolucion,

  // Historial
  obtenerHistorialDevolucion,

  // Secuencias
  previsualizarSiguienteNumero
};